/**
 * Which face the floating support button shows (issue #1046).
 *
 * - 'hostChat'  — logged-in host on a host surface: the support chat panel
 * - 'feedback'  — everyone else: the original feedback / contact form
 *
 * Participants must NEVER get the chat. That means both anonymous visitors on
 * participant-journey routes and logged-in accounts whose role is PARTICIPANT
 * resolve to 'feedback'. A host who wanders onto a participant surface (e.g.
 * testing their own session link) also gets the feedback form: chat is a host
 * workspace tool, and the participant journey stays as PR #902 shipped it.
 * Exercise-time hiding (useHideSupportWidget) is untouched by this and hides
 * the button entirely, whatever the mode.
 */

export type SupportWidgetMode = 'hostChat' | 'feedback';

/** Participant journey surfaces — an anonymous visitor here is a participant. */
export const PARTICIPANT_PREFIXES = ['/session', '/join', '/study', '/journey', '/participant', '/summary'];

export const isParticipantPath = (pathname: string): boolean =>
    PARTICIPANT_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));

export const resolveSupportWidgetMode = (input: {
    authenticated: boolean;
    role?: string | null;
    pathname: string;
}): SupportWidgetMode => {
    if (!input.authenticated) {
        return 'feedback';
    }
    if (input.role === 'PARTICIPANT') {
        return 'feedback';
    }
    if (isParticipantPath(input.pathname)) {
        return 'feedback';
    }
    return 'hostChat';
};
